;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import UserDetails from '../svg/UserDetails';

import Signup from '../auth/Signup';
import { Dictionaries } from '../../i18n/i18n-config';
import { getI18nUtils } from '../../i18n/i18n-utils';

const MySynergieSection = ({ dictionary }: { dictionary: Partial<Dictionaries> }): JSX.Element => {
  const { formatMessage } = getI18nUtils(dictionary);

  return (
    <Container>
      <div className="p-5">
        <Row>
          <Col md={{ size: 5 }} lg={{ offset: 1 }}>
            <UserDetails className="w-100" />
          </Col>
          <Col md={{ size: 7 }} lg={{ size: 5 }}>
            <h3 className="mb-3">{formatMessage({ id: 'my-synergie-subscribe-title' })}</h3>
            <ul>
              <li>{formatMessage({ id: 'application_followup' })}</li>
              <li>{formatMessage({ id: 'tailored_jobmatches' })}</li>
            </ul>
            <Signup dictionary={dictionary} />
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default MySynergieSection;
